var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('./../../template/msg/default-contactinfo-card.html');
var config = require('./../../global/config');
var getImgParams = require('./../../global/utils').convertImgParams;
var ActionType = require('./../../constant/ActionType'); 
var dispatcherAccurate = require('./../../global/dispatcherAccurate');
var dispatcher = require('./../../global/dispatcher');
var utils = require('./../../global/utils');
var isEmpty = utils.isEmpty;
var isAnonymousSession = utils.isAnonymousSession;

var DefaultContactinfoCard = function (options) {
  (function (self) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    BaseMsgItem.call(self, defaults);
  })(this);
};

DefaultContactinfoCard.prototype = Object.create(BaseMsgItem.prototype);
DefaultContactinfoCard.prototype.renderContent = function () {
  var self = this;
  var msg = this._data.msg;
  if (!msg) {
    return false;
  }
  var content = msg.content;
  var element = this._element;
  var contactinfo_content = element.find('.im-default-contactinfo-card-content'); 
  var more_foot = contactinfo_content.find('.im-default-contactinfo-foot')
  let nameInfo;
  if (msg.sender_info.remark) {
    nameInfo = msg.sender_info.remark.remark_name || msg.sender_info.user_name || '未知';
  } else {
    nameInfo = msg.sender_info.user_name || '未知';
  }
  if (isEmpty(nameInfo) && isAnonymousSession(msg.sender_info)) {
    nameInfo = '游客' + msg.sender_info.user_id;
  }
  let avatarInfo = msg.sender_info.avatar ? msg.sender_info.avatar :config['default-avatar'];
  let check_code = content.check_code ? content.check_code:'';
  let glanceData = {
    other_user_id: msg.sender_info.user_id?msg.sender_info.user_id:msg.sender_id,
    other_user_source: msg.sender_info.user_source?msg.sender_info.user_source:msg.sender_source,
    check_code: check_code
  }
  msg.glanceData = glanceData;
  //头像
  contactinfo_content.find('.im-default-contactinfo-header-avatar').attr('src',avatarInfo)
  // 名称
  if(utils.isEmojiCharacter(nameInfo)){
    contactinfo_content.find('.im-default-contactinfo-header-name').addClass('need-space')
  }
  contactinfo_content.find('.im-default-contactinfo-header-name').text(nameInfo)
  //点击查看  
  contactinfo_content.find('.im-default-contactinfo-foot-more').click(function(e){
    e.stopPropagation();
    dispatcher.dispatch({
      type: ActionType.GLANCE_CONTACTINFO,
      data: msg
    });
  })
  //点击重新索要
  more_foot.find('.im-default-contactinfo-foot-update-click').click(function(e){
    e.stopPropagation();
    dispatcher.dispatch({
      type: ActionType.ASK_CONTACTINFO,
      data: glanceData
    });
  })

  dispatcherAccurate.register(dispatcherAccurate.createKey(msg.msg_id), function (action) {
    if (!action.data || !action.type || !action.data.msg_id) {
        return;
    }
    if (action.data.msg_id === msg.msg_id) {
        switch (action.type) {
            case ActionType.GLANCE_CONTACTINFO_RETURN:
              let contactinfoData = action.data.contactinfoData?action.data.contactinfoData:'';
              var telDetail = contactinfoData.tel ? contactinfoData.tel:'';
              var wechatDetail = contactinfoData.wechat ? contactinfoData.wechat:'';
              //联系方式变更，请重新索要
              if(contactinfoData && !contactinfoData.is_uptodate){
                if(contactinfoData.msg_showtype && contactinfoData.msg_showtype == 'collect'){
                  more_foot.find(".im-default-contactinfo-foot-update").text('该用户的联系方式已变更')
                  more_foot.find(".im-default-contactinfo-foot-update-click").css('display','none')
                }else{
                  more_foot.find(".im-default-contactinfo-foot-update-click").css('display','block')
                }
                more_foot.find(".im-default-contactinfo-foot-update").css('display','block')
              }
              if(!telDetail){
                more_foot.find(".im-default-contactinfo-foot-tel").css('display','none')
              }
              if(!wechatDetail){
                more_foot.find(".im-default-contactinfo-foot-wechat").css('display','none')
              }
              more_foot.addClass('open')
              more_foot.find(".im-default-contactinfo-foot-tel-text").text(telDetail)
              more_foot.find(".im-default-contactinfo-foot-wechat-text").text(wechatDetail)
              more_foot.find(".im-default-contactinfo-foot-more").css('display','none')
              
              break;
            default:
              break;
        }
    }
  });
};

module.exports = DefaultContactinfoCard;
